import { getIdeationStageName } from 'helpers/topics';
import { Observable } from 'knockout';

interface IdeationToolsStageButtonConfig {
    stage: number
}

export default class TaskActivityIdeationToolsStageButton {
    title: Observable<string>
    stage: Observable<number>

    isActive = ko.observable(false);

    constructor(config: IdeationToolsStageButtonConfig) {
        this.title = ko.observable(getIdeationStageName(config.stage));
        this.stage = ko.observable(config.stage);
    }
}